import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import { AuthProvider } from './contexts/AuthContext';
import Header from './components/Header';
import Footer from './components/Footer';
import ProtectedRoute from './components/ProtectedRoute';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import BlogPage from './pages/BlogPage';
import BlogPostPage from './pages/BlogPostPage';
import PDSPage from './pages/products/PDSPage';
import CRSPage from './pages/products/CRSPage';
import KachurwahiPage from './pages/products/KachurwahiPage';
import WhatsAppPage from './pages/products/WhatsAppPage';
import PresentationPage from './pages/PresentationPage';
import MajhiMauliSmilePage from './pages/MajhiMauliSmilePage';
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';

const AppLayout = ({ children }) => {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');
  const isPresentationRoute = location.pathname === '/presentation';
  
  return (
    <>
      {!isAdminRoute && !isPresentationRoute && <Header />}
      {children}
      {!isAdminRoute && !isPresentationRoute && <Footer />}
    </>
  );
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppLayout>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/gramtek" element={<Navigate to="/products/pds" replace />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/blog" element={<BlogPage />} />
              <Route path="/blog/:id" element={<BlogPostPage />} />
              <Route path="/products/pds" element={<PDSPage />} />
              <Route path="/products/crs" element={<CRSPage />} />
              <Route path="/products/kachurwahi" element={<KachurwahiPage />} />
              <Route path="/products/whatsapp" element={<WhatsAppPage />} />
              <Route path="/presentation" element={<PresentationPage />} />
              <Route path="/majhi-mauli-smile" element={<MajhiMauliSmilePage />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin/dashboard" element={
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              } />
            </Routes>
          </AppLayout>
          <Toaster position="top-right" />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;